"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidthOfGridColumns = exports.getWidthOfContainerColumns = void 0;
var _tokens = require("../../tokens");
const getWidthOfContainerColumns = function (columnCount) {
  let breakpoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
  let gridGap = arguments.length > 2 ? arguments[2] : undefined;
  const outerWidth = _tokens.BREAKPOINT[breakpoint];
  const padding = parseInt(_tokens.GTR[_tokens.CONTAINER_PADDING_HORIZONTAL_AT_BP[breakpoint]], 10);

  // default to container gap at breakpoint if not specified
  const gap = typeof gridGap === 'number' ? gridGap : parseInt(gridGap || _tokens.GTR[_tokens.CONTAINER_GRID_GAP_AT_BP[breakpoint]], 10);
  return getWidthOfGridColumns(columnCount, 12, gap, outerWidth - padding * 2);
};
exports.getWidthOfContainerColumns = getWidthOfContainerColumns;
const getWidthOfGridColumns = (columnCount, totalColumns, gridGap, gridWidth) => Math.round(columnCount * (gridWidth + gridGap) / totalColumns - gridGap);
exports.getWidthOfGridColumns = getWidthOfGridColumns;